import React from 'react';
import target_id from "../json/reg_id_source.json";


export default function CheckID() {

  let now = new Date();
  console.log(now);

  for(let i = 0; i < target_id.length; ++i) {
    let scount = 0;
    for(let j = 0; j < target_id.length; ++j) {
      if (target_id[j] === target_id[i]) scount += 1;
    };
    if (scount > 1) {
      console.log(target_id[i], scount, i);
    }
  };

  console.log('End');
  console.log(now);

  return (
    <></>
  );
}
